import { i18n } from '@/core/lib/i18n';
import { multiProviderSportConfigs } from '@/core/lib/multiProviderSportConfig';
import { SportType } from '@/interface/enum';
import { useCustomerStore } from '@/store/customerStore';

export const sportTypeNameKeyMap: Partial<Record<SportType, string>> = {
    [SportType.EsportsForDisplay]: 'sport_type_name_9001',
    [SportType.Esports]: 'sport_type_name_32',
    [SportType.EsportsIm]: 'sport_type_name_5004',
    [SportType.MuayThaiForDisplay]: 'sport_type_name_9002',
    [SportType.MuayThai]: 'sport_type_name_muay_thai_sbo',
    [SportType.MuayThaiOneBx]: 'sport_type_name_5005',
};

export function useSportsListSportTypeName() {
    const customerStore = useCustomerStore();

    function getMultiProviderFallbackNameKey(sportType: SportType) {
        const config = multiProviderSportConfigs.find(item => item.sboSportType === sportType);
        if (!config) {
            return undefined;
        }

        const isChildrenAvailable = config.isChildrenAvailable({
            sboCurrency: customerStore.sboCurrency,
            playerType: customerStore.playerType,
        });
        if (isChildrenAvailable) {
            return undefined;
        }

        return sportTypeNameKeyMap[config.displaySportType];
    }

    const getSportsListSportTypeName = (sportType: SportType) => {
        const multiProviderFallbackNameKey = getMultiProviderFallbackNameKey(sportType);
        if (multiProviderFallbackNameKey) return i18n.t(multiProviderFallbackNameKey);

        const i18nKey = sportTypeNameKeyMap[sportType];
        return i18nKey ? i18n.t(i18nKey) : i18n.t(`sport_type_name_${sportType}`);
    };

    return {
        getSportsListSportTypeName,
    };
}
